import { Schema as S } from "effect";

/**
 * KIM Account Info Schema
 *
 * Information about the practice KIM account for eEB communication.
 */
export const KimAccountInfoSchema = S.Struct({
  /** KIM email address */
  kimAddress: S.String,
  /** Practice name */
  practiceName: S.String,
});

/**
 * Get KIM Account Response Schema
 *
 * Returns KIM account info or null if not configured.
 */
export const GetKimAccountResponseSchema = S.Union(
  [KimAccountInfoSchema,
  S.Null]
);

export type GetKimAccountResponse = S.Schema.Type<
  typeof GetKimAccountResponseSchema
>;

